<template>
  <v-container fluid class="py-0" :style="'height:' + computedPageHeight + 'px'">

    <v-row>
      <v-col
        class="pa-0">

        <!-- on image bar -->
        <v-row class="carousel-top-element white--text">
          <v-col class="py-0 max-width-1200 mx-auto">
            <app-bar-menu
              component="Hardware"
              logo="light"
              dark="dark">
            </app-bar-menu>
          </v-col>
        </v-row>

        <!-- hero -->
        <v-card flat dark>
          <v-img
            id="img-main"
            src="@/assets/img/hw-01.jpeg"
            class="grey lighten-2"
            cover
            :max-height="computedPageHeight"
            :style="'height:' + computedPageHeight + 'px'">
            <v-row
              class="fill-height overlay mx-0"
              align="center"
              justify="center">
              <v-col class="">
                <v-row class="mx-0">
                  <!-- <v-col class="text-center display-4 font-weight-medium">
                    {{ $t('rubin.rubin') }} {{ $t('service.itSolutions.title') }}
                  </v-col> -->
                  <v-col class="text-center">
                    <span class="mr-4 subsite-title-1" style="line-height:6rem;">{{ $t('rubin.rubin') }}</span>
                    <span class="subsite-title-2" style="line-height:3rem;">{{ $t('service.hardware.title') }}</span>
                  </v-col>
                </v-row>
                <v-row class="mx-0">
                  <v-col class="text-center pa-0 subsite-title-3">
                    {{ $t("service.hardware.subtitle") }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- ic img -->
            <v-row class="carousel-bottom-controls">
              <v-col class="pa-0 img-ic-box flip-x">
              </v-col>
            </v-row>

            <!-- landing scroll menu -->
            <v-row class="menu landing-scroll">
              <v-col class="max-width-1200 px-0 mx-auto">
                <v-btn
                  v-for="(item,index) in sections"
                  :key="index"
                  text
                  @click="scrollTOSection(item.id)">
                    {{ $t(item.title) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-img>

        </v-card>

        <v-row class="mx-1">
          <v-col id="service">
            <Service></Service>
          </v-col>
        </v-row>


        <v-row class="mx-1">
          <v-col id="catalog">
            <Catalog></Catalog>
          </v-col>
        </v-row>

        <v-row class="mx-0 bg-ruby">
          <v-col>
            <Contact></Contact>
          </v-col>
        </v-row>


      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import AppBarMenu from '@/components/Common/AppBar.vue';
  import DataComponentBase from '@/commons/DataComponentBase';

  import Service              from '@/components/Hardware/Service.vue'
  import Catalog              from '@/components/Hardware/Catalog.vue'
  import Contact              from '@/components/Common/Contact.vue'

  export default {
    name: 'Hardware',
    metaInfo: {
      title: 'Hardver',
      titleTemplate: '%s - Rubin Informatika',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Több, mint két évtizedes tapasztalattal rendelkezünk a felügyeleti-berendezések és programok fejlesztése, gyártása terén.'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'hardver, energiamegtakarítás, klíma-üzemidő miatt a karbantartási költségek üzembiztonság vészüzemmel kombinált, hiba-előrejelzés és javítási feladatok támogatása'
        }
      ],
      __dangerouslyDisableSanitizers: ['meta'],
    },

    extends: DataComponentBase,

    components: {
      AppBarMenu,
      Service,
      Catalog,
      Contact,
    },

    data: () => ({
      sections: [
        { id: "service",       title: "hardwer.service.title", },
        { id: "catalog",       title: "hardwer.catalog.title", },
      ],

    }),

    mounted() {
    },

    computed: {
    },

    methods: {
      scrollTOSection(id) {
        var section = document.getElementById(id);
        section.scrollIntoView();
      }
    },

    watch: {
      computedWidth() {
      }
    },
  }

</script>

<style src="../Style.css">
</style>
